<template>
  <div class="items-grid-container">
    <items-grid
      :items="elements"
      :title="title"
      :search="local_search"
      :can-upload="isManager && currentFolder && currentFolder.pk > 0"
      :can-delete="isManager"
      :current-folder="currentFolder"
      :count="itemsCount"
      @search="onSearch"
      @upload-clicked="onUploadClicked"
      @delete="onDeleteItem"
      @reached-bottom="loadMore"
    />
    <upload-collateral-modal
      v-model="modal"
      :uploading="uploading"
      :count="nUploaded"
      @upload="onUpload"
    />
  </div>
</template>
<script>

import api from '@/_api';
import { EventBus } from '@/event-bus.js';
import Listable from '@/components/mixins/listable.js';
import ItemsGrid from './ItemsGrid';
import UploadCollateralModal from './UploadCollateralModal';

export default {
  name: 'ItemsGridContainer',
  components: { ItemsGrid, UploadCollateralModal },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'collateral',
    },
    pageSize: {
      type: Number,
      default: 30,
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
  },
  data() {
    return {
      modal: false,
      uploading: false,
      nUploaded: 0,
      currentFolderPk: -1,
      local_search: '',
    };
  },
  computed: {
    title() {
      return (this.search && this.search.length) ? `Search results (${this.elements.length})` : this.currentFolder.name;
    },
    currentFolder() {
      return this.$store.state.folders.item;
    },
    isManager() {
      return this.$store.state.account.user.profile.role.includes('manager');
    },
    folderItems() {
      if (!this.$store.state.folders) {
        return [];
      }
      return this.$store.state.folders.items;
    },
    allItems() {
      if (!this.$store.state.collateral) {
        return [];
      }
      return this.$store.state.collateral.items;
    },
    itemsCount() {
      return this.$store.state.collateral.count;
    },
  },
  watch: {
    currentFolder(newVal) {
      if (this.currentFolderPk !== this.currentFolder.pk) {
        this.currentFolderPk = this.currentFolder.pk;
        this.reset();
        if (this.currentFolderPk && this.currentFolderPk > 0) this.queryParams = { folder: this.currentFolderPk };
        else this.queryParams = {};
      }
    },
    search(newval) {
      if (!newval) {
        return;
      }
      this.$emit('no-folder', newval.length !== 0);
    },
  },
  beforeMount() {
    this.reset();
  },
  methods: {
    // eslint-disable-next-line no-undef, func-names
    onSearch: _.debounce(function (evt) {
      this.local_search = evt;
      if (this.currentFolderPk !== -1) {
        // eslint-disable-next-line no-param-reassign
        evt = `${this.currentFolder.name} ${evt}`;
      }
      this.search = evt;
    }, 200),
    onUploadClicked() {
      this.modal = true;
    },
    onUpload(files) {
      console.log('ON UPLOAD22');
      // Post new collaterals
      if (this.currentFolder.pk < 0) {
        console.warn('Tried to upload to "ALL"');
        return;
      }
      if (this.uploading) {
        console.warn('Tried to upload while already uploading');
        return;
      }
      console.log('Starting upload of ', files.length, 'files');
      let finished = 0;
      this.nUploaded = 0;
      this.uploading = true;
      // eslint-disable-next-line array-callback-return
      files.map((file) => {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('folder', this.currentFolder.pk >= 0 ? this.currentFolder.url : null);
        api.post('/collateral/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }).then(() => {
          // before this.nUploaded++;
          this.nUploaded += 1;
        }).catch((error) => {
          console.error('Upload failure: ', error.response && error.response.status ? error.response.status : '?');
        }).finally(() => {
          // before, finished++;
          finished += 1;
          if (finished === files.length) {
            console.log('Processed all files. ', this.nUploaded, 'of', files.length, 'were successful');
            this.uploading = false;
            this.modal = false;
            this.refreshFolders();
            // Notify with toast
            if (this.nUploaded === files.length) EventBus.$emit('toast', `Uploaded ${this.nUploaded} items`);
            else if (this.nUpload > 0) EventBus.$emit('toast', `Uploaded ${this.nUploaded} items with ${files.length - this.nUploaded} errors`);
            else EventBus.$emit('toast-error', 'Failed to upload! Please retry');
          }
        });
      });
    },
    refreshFolders() {
      this.$store.dispatch('folders/getAll');
      if (this.currentFolder.pk >= 0) {
        this.$store.dispatch('collateral/getAll');
      } else {
        this.$store.dispatch('collateral/getAll', { folder: this.currentFolder.pk });
      }
      if (this.currentFolder.pk >= 0) this.$store.dispatch('folders/getItem', this.currentFolder.pk);
    },
    onDeleteItem(itemPk) {
      this.$store.dispatch('collateral/deleteItem', itemPk).then(() => {
        this.refreshFolders();
      });
    },
    loadMoreImages() {
      if (this.loading) {
        console.debug('already loading');
        return;
      }
      // before, this.truePage++;
      this.truePage += 1;
      console.log('True page value: ', this.truePage);
    },
  },
};
</script>
